import { Flex, Image, Text } from "@chakra-ui/react"

import { useReservationsContext } from "providers/ReservationsProvider/ReservationsProvider"
import { useUI } from "providers/UIProvider"

const ReservationDetailsService: React.FC = () => {
  const { T } = useUI()
  const { currentReservation: reservation } = useReservationsContext()

  return (
   <Flex
    border="1px solid #E9F2FD"
    borderTop="unset"
    width="283px"
    height="120px"
    flexDirection="column"
    padding="14px 0 20px  24px"
   >
    <Text opacity={0.7} mb={"10px"} fontSize={"base"}>
      {T("booking.details.modal.selected.service")}
    </Text>
    <Text fontSize={"base"}>{reservation?.washType}</Text>
    <Flex
      mb={"4px"}
      alignItems={"center"}
      justifyContent={"center"}
      height={"40px"}
      width={"86px"}
      background={"#E9F2FD"}
      borderRadius={"base"}
    >
      <Image src={reservation?.washTypeLogoUrl}/>
    </Flex>
   </Flex>
  )
}

export default ReservationDetailsService